import React, { useState, useMemo, useEffect } from 'react'
import styled from 'styled-components/macro';
import { Spacer } from 'components/atoms';
import { InputIcon, Pagination } from 'components/molecules';
import { SubwebsTable } from 'components/organisms';
import { injectIntl } from 'react-intl'
import { intlType } from 'types'
import { useUserContext } from 'context/UserContext';
import Fuse from 'fuse.js'

const SubwebsPagesTable = ({ intl }) => {
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [{
    user
  }] = useUserContext();

  const userSubwebs = useMemo(() => {
    if (user && user.subwebs && user.subwebs.length > 0) return user.subwebs
    return []
  }, [user])

  const handleSearch = (e) => {
    setSearch(e.target.value)
    setPage(1)
  }

  const fuse = useMemo(() => new Fuse(userSubwebs, {
    threshold: 0.1,
    keys: ['description', 'initials', 'slug']
  }), [userSubwebs])

  const filteredSubwebs = useMemo(() => {
    if (search === '') return userSubwebs
    return fuse.search(search).map(({ item }) => item)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, fuse])

  const totalRecords = filteredSubwebs.length

  const noDataText = useMemo(() => (search === '' ? 'Sem resultados' : `Sem resultados para a pesquisa "${search}"`), [search])

  useEffect(() => {
    setPage(1)
  }, [filteredSubwebs])

  // react-table pages start at 0 while rc-pagination starts at 1
  const tablePage = useMemo(() => page - 1, [page])

  return (
    <TableWrapper>
      <Spacer bottom="xl">
        <InputIcon
          icon="search"
          placeholder={intl.formatMessage({ id: 'subwebs.search' })}
          value={search}
          onChange={handleSearch}
        />
      </Spacer>
      <Spacer bottom="m">
        <div>
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </div>
      </Spacer>
      <SubwebsTable subwebs={filteredSubwebs} noDataText={noDataText} page={tablePage} />
      <Spacer top="m">
        <div>
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </div>
      </Spacer>
    </TableWrapper>
  )
}

const TableWrapper = styled.div``

SubwebsPagesTable.propTypes = {
  intl: intlType.isRequired,
}

export default injectIntl(SubwebsPagesTable)
